import { makeStyles } from "@material-ui/styles";


export const useStyle = makeStyles(() => ({

}));